import { render, staticRenderFns } from "./ActividadPreparacion.vue?vue&type=template&id=16246a7b&"
import script from "./ActividadPreparacion.vue?vue&type=script&lang=ts&"
export * from "./ActividadPreparacion.vue?vue&type=script&lang=ts&"
import style0 from "./ActividadPreparacion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('16246a7b', component.options)
    } else {
      api.reload('16246a7b', component.options)
    }
    module.hot.accept("./ActividadPreparacion.vue?vue&type=template&id=16246a7b&", function () {
      api.rerender('16246a7b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/Add/modal-altas/ActividadPreparacion.vue"
export default component.exports